import { render, staticRenderFns } from "./pbl4.vue?vue&type=template&id=6e58afb3&scoped=true&"
import script from "./pbl4.vue?vue&type=script&lang=js&"
export * from "./pbl4.vue?vue&type=script&lang=js&"
import style0 from "./pbl4.vue?vue&type=style&index=0&id=6e58afb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e58afb3",
  null
  
)

export default component.exports